import { Typography } from '@mui/material';
import styles from './StickyNavBarNew.module.scss';
import { ContainedButton, LinkButton } from '../../../../../commons/hoc';
import { getProducts } from '../../../../../commons/utils/productsHelper';
import { categoryBasedContent } from './contants';
import { useEffect, useState, useRef } from 'react';
import { StickyDownArrow } from '../../../../../src/assets/images/icons';
import { Divider, Link } from '../../../../../commons/components/ui';
import { useRouter } from 'next/router';
import { ORDER_PHONENO } from '../../../../../commons/Constants';
import PhoneIcon from '../../../../../src/assets/images/icons/phone.svg';
import { productImages } from '../../../../../src/images';
import Image from 'next/image';
import useMediaQuery from '@mui/material/useMediaQuery';

const StickyNavBarNew = ({
  tags = {},
  ctaClick = () => {},
  productKey = '',
  productType = '',
  ...rest
}) => {
  const products = getProducts();
  const stickyNavRef = useRef(null);
  const [isIntersecting, setIsIntersecting] = useState(false);
  const { asPath } = useRouter();
  const [showDropdown, setShowDropDown] = useState(false);
  const [activeHash, setActiveHash] = useState('');
  const [activeText, setActiveText] = useState('');
  const Router = useRouter();
  let currentProduct = {};
  let anchorTags = {};
  let productInFocus = '';
  if (productType) {
    let content = categoryBasedContent[productType];
    currentProduct = products[content?.productKey];
    anchorTags = content?.tags;
    productInFocus = content?.productKey;
  } else {
    currentProduct = products[productKey];
    anchorTags = { ...tags };
    productInFocus = productKey;
  }
  const isTab = useMediaQuery('(max-width:992px)');
  useEffect(() => {
    let hash = `${asPath.split('#')[1]}` || '';
    let tag = {};
    if (hash && anchorTags.hasOwnProperty(hash)) {
      tag = anchorTags[hash];
    } else {
      tag = Object.values(anchorTags)[0];
    }
    setActiveHash(tag.href);
    setActiveText(tag.text);
  }, [asPath]);

  const options = {
    root: null,
    rootMargin: '0px 0px -100%',
    threshold: [0],
  };

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsIntersecting(entry.isIntersecting);
    }, options);
    observer.observe(stickyNavRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      id="NewSticky"
      className={`${styles.stickyNavExtender} ${
        isIntersecting ? styles.isSticky : styles.stickyNav
      }`}
      ref={stickyNavRef}
    >
      <div className={styles.stickyNavContainer}>
        <div className={styles.stickyNavContent}>
          {!isIntersecting && !isTab && (
            <Divider
              stretchScreen={true}
              className={styles.stickyBottomBorder}
            />
          )}
          <div className={styles.stickyNavDefaultContainer}>
            <div
              className={styles.highlightedProduct}
              onClick={() => {
                if (window)
                  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
              }}
            >
              <div className={styles.highlightedProductImg}>
                <Image
                  src={productImages[currentProduct.key]}
                  width={43}
                  height={60}
                  objectFit="contain"
                />
              </div>
              <div>
                <Typography
                  variant="h3"
                  component="span"
                  color={isIntersecting ? 'primary' : 'white'}
                  noWrap
                >
                  {currentProduct?.title}
                </Typography>
                <div
                  className={`${styles.salesPhoneContent} ${
                    isIntersecting ? styles.dark : styles.light
                  }`}
                >
                  <PhoneIcon />
                  <Link href={`tel:+1${ORDER_PHONENO}`}>
                    <Typography
                      variant="h5"
                      component="span"
                      color={isIntersecting ? 'primary' : 'white'}
                      className={styles.subtitle}
                      noWrap
                    >
                      {ORDER_PHONENO}
                    </Typography>
                  </Link>
                </div>
              </div>
            </div>
            <div className={styles.anchorsContainer}>
              {Object.entries(anchorTags).map(([tag, data], index) => {
                const { text, ...rest } = data;
                return (
                  <LinkButton
                    btnType={isIntersecting ? 'dark' : 'light'}
                    scroll={false}
                    {...rest}
                    className={`${
                      activeHash === data.href
                        ? styles.activeItem
                        : styles.linkBtn
                    }`}
                    onClickHandler={() => {
                      if (activeHash !== data.href) {
                        setActiveText(data.text);
                        setActiveHash(data.href);
                      }
                    }}
                  >
                    {text}
                  </LinkButton>
                );
              })}
            </div>
            <div className={styles.addToCartBtnContainer}>
              <ContainedButton
                btnType={isIntersecting ? 'dark' : 'light'}
                onClick={() => {
                  Router.push('#buy', undefined, {
                    shallow: true,
                    scroll: false,
                  });
                  ctaClick(productInFocus);
                }}
              >
                Subscribe Now
              </ContainedButton>
            </div>
          </div>
          {isTab && (
            <Divider
              stretchScreen={true}
              className={
                isIntersecting
                  ? styles.stickyBottomBorderLight
                  : styles.stickyBottomBorder
              }
            />
          )}

          <div
            className={styles.responsiveMenu}
            onClick={() => {
              setShowDropDown(!showDropdown);
            }}
          >
            <div className={styles.responsiveContainer}>
              <div className={styles.responsiveTitle}>
                <Typography
                  variant="h5"
                  color={isIntersecting ? 'primary' : 'white'}
                >
                  {activeText}
                </Typography>
              </div>
              <div
                className={`${styles.responsiveArrow} ${
                  showDropdown ? styles.isActive : ''
                }`}
              >
                <StickyDownArrow color={isIntersecting ? '#004152' : 'white'} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`${styles.navUl} ${showDropdown ? styles.showDropdown : ''}`}
      >
        {Object.entries(anchorTags).map(([tag, data], index) => {
          const { text, ...rest } = data;
          return (
            <>
              <Link
                className={`${styles.responsiveMenu} ${
                  activeHash === data.href ? styles.activeItem : ''
                }`}
                {...rest}
                scroll={false}
                onClickHandler={() => {
                  setShowDropDown(false);
                  if (activeHash !== data.href) {
                    setActiveText(data.text);
                    setActiveHash(data.href);
                  }
                }}
              >
                <div className={styles.responsiveContainer}>
                  <div className={styles.responsiveTitle}>
                    <Typography variant="h5" color="primary.main">
                      {text}
                    </Typography>
                  </div>
                </div>
              </Link>
              <Divider
                stretchScreen={true}
                className={styles.stickyBottomBorder}
              />
            </>
          );
        })}
      </div>
    </div>
  );
};

export default StickyNavBarNew;
